import isAdmin from './isAdmin';
import isParent from './isParent';

const KIDS_MANAGER_GROUPS = ['Director', 'Administrative', 'UpperManagement'];

export const canCreateKids = (user: any): boolean =>
  isAdmin(user) || KIDS_MANAGER_GROUPS.includes(user?.groupPermission?.name);

export const canDeleteKids = (user: any): boolean => canCreateKids(user);

export const canEditKids = (user: any): boolean =>
  canCreateKids(user) || user?.groupPermission?.name === 'EducationDirectorAdminAssistant';

export const canManageEnrollmentFiles = (user: any): boolean => isAdmin(user) || !isParent(user);

export default canCreateKids;
